<template>
  <div class="zm-badge">
    <slot></slot>
    <transition name="zm-zoom-in-center">
      <sup
        v-show="!hidden && (content || content === 0 || isDot)"
        v-text="content"
        class="zm-badge__content"
        :class="{ 'is-fixed': $slots.default, 'is-dot': isDot }">
      </sup>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ZmBadge',

  props: {
    value: {},
    max: Number,
    isDot: Boolean,
    hidden: Boolean
  },

  computed: {
    content() {
      if (this.isDot) return;

      const value = this.value;
      const max = this.max;

      if (typeof value === 'number' && typeof max === 'number') {
        return max < value ? `${max}+` : value;
      }

      return value;
    }
  }
};
</script>

<style lang="scss">
  @import "../../scss/mixins/mixins";
  @import "../../scss/common/var";

  @include b(badge) {
    position: relative;
    vertical-align: middle;
    display: inline-block;

    @include e(content) {
      background-color: $--badge-fill;
      border-radius: $--badge-radius;
      color: $--color-white;
      display: inline-block;
      font-size: $--badge-font-size;
      height: $--badge-size;
      line-height: $--badge-size - 2;
      padding: 0 $--badge-padding;
      text-align: center;
      white-space: nowrap;
      border: 1px solid $--color-white;

      @include when(fixed) {
        position: absolute;
        top: 0;
        right: #{1 + $--badge-size / 2};
        transform: translateY(-50%) translateX(100%);

        @include when(dot) {
          right: 5px;
        }
      }

      @include when(dot) {
        height: 8px;
        width: 8px;
        padding: 0;
        right: 0;
        border-radius: 50%;
      }
    }
  }
</style>
